import * as React from 'react';
import { clsx } from 'clsx';

import { EPromoType } from '../../types/newBuldings/promo';
import { getPromoClassName, getPromoIcon } from './helpers';
import * as styles from './DiscountCard.css';

interface IDiscountCardProps {
  name: React.ReactNode;
  authorName: React.ReactNode;
  dueDate: React.ReactNode;
  displayedNewBuildings: React.ReactNode;
  promoType: EPromoType;
  onClick(): void;
}

export function DiscountCard({
  promoType,
  name,
  onClick,
  authorName,
  dueDate,
  displayedNewBuildings,
}: IDiscountCardProps) {
  const promoClassName = getPromoClassName(promoType);
  const icon = getPromoIcon(promoType);

  return (
    <article className={clsx(styles['card'], promoClassName)} onClick={onClick} data-testid="DiscountCard">
      {icon && <div className={styles['icon']}>{icon}</div>}
      <div className={styles['content']}>
        <div className={styles['title']}>{name}</div>
        {authorName}
        {dueDate && <div>{dueDate}</div>}

        <div className={styles['newbuildings-wrapper']}>
          {displayedNewBuildings && <div className={styles['newbuildings']}>{displayedNewBuildings}</div>}
        </div>
      </div>
    </article>
  );
}
